import { faBell, faBellSlash } from '@fortawesome/pro-regular-svg-icons';
import { faSearch } from '@fortawesome/pro-solid-svg-icons';
import { Location } from 'history';
import isNumber from 'lodash-es/isNumber';
import {
    CONFIRM,
    COUNSELLING_ANSWERED,
    COUNSELLING_IS_ARCHIVED,
    FORUM_ADD_QUESTION,
    SEO_DESCRIPTION_FORUM_POST_perex,
    SEO_TITLE_FORUM_POST_title,
    SEO_TITLE_FORUM_POST_title_AT_PAGE_pagenum,
    TURN_NOTIFICATIONS_OFF,
    TURN_NOTIFICATIONS_ON,
} from 'mk/autogenerated/translations/PostDetailPage.c215428516effb168251449d946a9d32'
import { boldize } from 'mk/bazaar/common/filters';
import { hasAds } from 'mk/bazaar/common/userUtils';
import { analyticsStoreEvent } from 'mk2/actions';
import { contestsHomeUrl, contestsPostDetailUrl } from 'mk2/apps/contests/urls';
import { counsellingsPostDetailUrl } from 'mk2/apps/counsellings/urls';
import { addCounsellingQuestion, postSendHeart } from 'mk2/apps/forum/actions';
import { CommentFormData, COMMENT_CREATE_FORM_NAME } from 'mk2/apps/forum/components/CommentCreateEditForm';
import PostDetail from 'mk2/apps/forum/containers/PostDetail/PostDetail';
import {
    postDetailAddCommentUnauthenticated,
    postDetailCommentCreateTrigger,
    postDetailCommentDeleteTrigger,
    postDetailCommentReply,
    postDetailDeletePost,
    postDetailFetchTrigger,
    postDetailMoveUpComment,
    postDetailScrollToTrigger,
    postDetailToggleCommentHighlight,
    postDetailToggleNotifications,
    postDetailTrackTrigger,
} from 'mk2/apps/forum/containers/PostDetail/PostDetail.actions';
import { POST_DETAIL_MENU_MORE } from 'mk2/apps/forum/containers/PostDetail/PostDetail.constants';
import styles from 'mk2/apps/forum/containers/PostDetail/PostDetail.mscss';
import postsDetailReducer, {
    PostDetailPageState,
    PostDetailVirtualPageState,
} from 'mk2/apps/forum/containers/PostDetail/PostDetail.reducers';
import postsDetailSaga from 'mk2/apps/forum/containers/PostDetail/PostDetail.sagas';
import {
    findPostDetailPost,
    getForumPostsDetailState,
    getForumPostDetailPageState,
    getForumPostDetailState,
    getForumPostDetailVirtualPageState,
} from 'mk2/apps/forum/containers/PostDetail/PostDetail.selectors';
import { PostDetailRight } from 'mk2/apps/forum/containers/PostDetail/PostDetailRight';
import { postDetailUrl, FORUM_COMMENT_MENU_MORE } from 'mk2/apps/forum/helpers';
import { getForumNotificationsOn } from 'mk2/apps/forum/reducers';
import {
    BrandDaysCampaignEntity,
    BrandDaysCampaignSchema,
    ContestEntity,
    ContestSchema,
    CounsellingEntity,
    CounsellingSchema,
    ForumMessageEntity,
    ForumMessageSchema,
    PageRef,
    PostEntity,
    PostSchema,
} from 'mk2/apps/forum/schemas';
import { breadcrumbsForum, discussionForumPosting, postOG } from 'mk2/apps/forum/structuredData';
import { forumPostDetailUrl, forumSearchUrl, forumTopicUrl } from 'mk2/apps/forum/urls';
import { isContestPost, isCounsellingPost, parsePageNumber } from 'mk2/apps/forum/utils';
import { Btn,  BtnLayout, BtnType } from 'mk2/components/Btn';
import { FormPageType } from 'mk2/constants/enums';
import { complaintOpenTrigger } from 'mk2/containers/Complaint/Complaint.actions';
import { ComplaintTargetType } from 'mk2/containers/Complaint/Complaint.schemas';
import {
    getComplaintsShownForForumComments,
    getComplaintShownForForumPost,
} from 'mk2/containers/Complaints/Complaints.selectors';
import { menuToggle } from 'mk2/containers/Menu/Menu.actions';
import { FORUM_TOPICS_WITH_NEWSLETTER } from 'mk2/containers/PregnancyNewsletter/PregnancyNewsletter.constants';
import { mkReduxFormMapDispatchToProps, mkReduxFormMapStateToProps } from 'mk2/decorators/mkReduxForm';
import { getAllPlaintext, getFirstParagraphsPlaintext } from 'mk2/helpers/article_ast/utils';
import { cacheLast } from 'mk2/helpers/cache';
import { showWarningToastAction } from 'mk2/helpers/toasts';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { url } from 'mk2/helpers/urls';
import FormPage, { FormPageDispatchProps, FormPageStateProps } from 'mk2/pages/FormPage';
import { AnchorLeaderboardProps, BrandingProps, HalfpageProps } from 'mk2/pages/Page';
import {
    getRequestBaseUrl,
    getRequestDeviceIsIOS,
    getRequestDeviceMobile,
    getRequestPermissions,
    getRequestUser,
    AppState,
} from 'mk2/reducers';
import { LoadingState } from 'mk2/reducers/loadingState';
import {
    ContentItemEntity,
    ContentItemSchema,
    EshopProductEntity,
    EshopProductSchema,
    UserEntity,
    WikiArticleEntity, WikiArticleSchema,
} from 'mk2/schemas';
import { getDenormalizedEntities, getDenormalizedEntitiesMapList, getDenormalizedEntity } from 'mk2/selectors';
import { interpolate } from 'mk2/services/i18n';
import { Store } from 'mk2/store/configureStore';
import React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps, StaticContext } from 'react-router';

export enum ScrollToPosition {
    FirstComment = 'first',
    LastComment = 'last',
}

// aby sme vedeli rozlisit medzi poradnami a forum uz pocas LoadingState.INIT a LoadingState.LOADING
// a zobrazovali tak spravne UI
export enum PostDetailViewType {
    Forum,
    AskAnExpert,
    Contest,
}

export interface OwnProps {
}

export interface StateProps extends FormPageStateProps {
    post: PostEntity;
    isMyAnonymousPost: boolean;
    comments: ForumMessageEntity[];
    commentsWithComplaint: ForumMessageEntity[];
    commentsComplaintOpened: boolean[];
    pageRef: PageRef; // page number or symbolic name (e.g. 'last') of current page. Null if page=... value is invalid
    numberOfPages: number;
    isMobile: boolean;
    isIOS: boolean;
    requestUserPermissions: string[];
    initialValues: CommentFormData;
    requestUser: UserEntity;
    loadingState: LoadingState;
    errorMessage: string;
    postComplaintOpened: boolean;
    baseUrl: string;
    notificationsOn: number[];
    commentToBeHighlighted: number | 'last';
    similarPosts: PostEntity[];
    recentPosts: PostEntity[];
    backlinksBox: ContentItemEntity;
    viewType: PostDetailViewType;

    contest: ContestEntity | null;   // ak sme v poste z topicu Sutaze, obsahuje data o aktualnej sutazi
    contestAlreadyParticipated: boolean;
    counselling: CounsellingEntity;
    brandDaysCampaign: BrandDaysCampaignEntity;
    brandDaysPosts: PostEntity[];

    eshopProductsHeader: EshopProductEntity[];
    eshopProducts: EshopProductEntity[];
    eshopProductsFooter: EshopProductEntity[];

    eshopProductsOfEshopNodes: Record<string, EshopProductEntity[]>;

    promoReviewArticlesHeader: WikiArticleEntity[];
    promoReviewArticlesMiddle: WikiArticleEntity[];
    promoReviewArticlesFooter: WikiArticleEntity[];

    userCanHavePregnancyNewsletter: boolean;
    postCanHavePregnancyNewsletter: boolean;
}

export interface DispatchProps extends FormPageDispatchProps {
    onLoad(topicSlug: string, postSlug: string, page: PageRef, currentUrl: Location, numCommentsBeforeLoad: number);
    onReply(username: string, textArea: HTMLTextAreaElement);
    onReport(entity: ComplaintTargetType, id: number);
    onToggleMenuMore(id: number);
    onStoreEvent(name: string, props: any);
    onAddComment(postId: number, values: CommentFormData);
    onAddCommentUnauthenticated();
    onDeleteComment(id: number);
    onMoveUpComment(id: number);
    onScrollTo(scrollto: ScrollToPosition);

    onToggleMenuMorePostDetail();
    onToggleNotifications(username: string, channelId: number, follow: boolean);
    onDelete(id: number);

    onTrackEdit(itemId: number);
    onSendHeart();
    onToggleCommentHighlight(key: string, commentId: number | 'last');
    onShowWarningToast(message: string | React.ReactNode);
    onAddCounsellingQuestion(counselling: CounsellingEntity);
}

interface StaticContextWithUrl extends StaticContext {
    url: string;
}

export type RouteProps = RouteComponentProps<{
    topicSlug: string;
    postSlug: string;
}, StaticContextWithUrl>;
export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

const initialValues = {
    text: '',
    photos: [],
    sticker: null,
};

export default class PostDetailPage extends FormPage<OwnProps & RouteProps, StateProps, DispatchProps> {

    private onToggleNotificationsCache = cacheLast();
    private onAddPostClicked = cacheLast();

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const { match: { params: { topicSlug, postSlug } } } = ownProps;

            const pageRef = parsePageNumber(ownProps.location);
            const postsDetailState = getForumPostsDetailState(state);
            const postDetailState = getForumPostDetailState(state, topicSlug, postSlug);
            const postDetailPageState: PostDetailPageState | PostDetailVirtualPageState = isNumber(pageRef)
                ? getForumPostDetailPageState(state, topicSlug, postSlug, pageRef)
                : getForumPostDetailVirtualPageState(state, topicSlug, postSlug, pageRef);
            const post: PostEntity = findPostDetailPost(state, topicSlug, postSlug);

            const commentIds = (postDetailPageState as PostDetailPageState).commentIds;
            const comments = !isNumber(pageRef) || commentIds === null
                ? null
                : getDenormalizedEntities<ForumMessageEntity>(state, ForumMessageSchema, commentIds);

            const similarPosts = getDenormalizedEntities<PostEntity>(state, PostSchema, postDetailState.similarPostIds);
            const recentPosts = getDenormalizedEntities<PostEntity>(state, PostSchema, postDetailState.recentPostIds);
            const backlinksBox = getDenormalizedEntity<ContentItemEntity>(state, ContentItemSchema, postDetailState.backlinksBoxId);
            const commentsWithComplaint = getDenormalizedEntities<ForumMessageEntity>(state, ForumMessageSchema, postDetailState.commentsWithComplaintIds);
            const userCanHavePregnancyNewsletter = postsDetailState.userCanHavePregnancyNewsletter;
            const postCanHavePregnancyNewsletter = post?.topic?.slug && FORUM_TOPICS_WITH_NEWSLETTER.includes(post.topic.slug);
            const eshopProductsOfEshopNodes = getDenormalizedEntitiesMapList<EshopProductEntity>(
                state,
                EshopProductSchema,
                postDetailState.eshopProductsOfEshopNodes,
            );

            return {
                ...mkReduxFormMapStateToProps(COMMENT_CREATE_FORM_NAME)(state),
                viewType: PostDetailViewType.Forum,
                post,
                isMyAnonymousPost: postDetailState.isMyAnonymousPost,
                comments,
                commentsWithComplaint,
                pageRef,
                numberOfPages: postDetailState.numberOfPages,
                loadingState: postDetailPageState.loadingState,
                errorMessage: postDetailPageState.errorMessage,
                isMobile: getRequestDeviceMobile(state),
                isIOS: getRequestDeviceIsIOS(state),
                initialValues,
                requestUserPermissions: getRequestPermissions(state),
                requestUser: getRequestUser(state),
                postComplaintOpened: getComplaintShownForForumPost(state, post),
                commentsComplaintOpened: getComplaintsShownForForumComments(state, comments),
                baseUrl: getRequestBaseUrl(state),
                notificationsOn: getForumNotificationsOn(state),
                commentToBeHighlighted: postDetailState.commentToBeHighlighted,
                similarPosts,
                recentPosts,
                backlinksBox,

                eshopProductsOfEshopNodes,

                contest: getDenormalizedEntity<ContestEntity>(state, ContestSchema, postDetailState.contestId),
                contestAlreadyParticipated: postDetailState.contestAlreadyParticipated,
                counselling: getDenormalizedEntity<CounsellingEntity>(state, CounsellingSchema, postDetailState.counselling),
                brandDaysCampaign: getDenormalizedEntity<BrandDaysCampaignEntity>(state, BrandDaysCampaignSchema, postDetailState.brandDaysCampaignId),
                brandDaysPosts: getDenormalizedEntities<PostEntity>(state, PostSchema, postDetailState.brandDaysPostsIds),

                eshopProductsHeader: getDenormalizedEntities<EshopProductEntity>(state, EshopProductSchema, postDetailState.eshopProductsHeaderIds),
                eshopProducts: getDenormalizedEntities<EshopProductEntity>(state, EshopProductSchema, postDetailState.eshopProductsIds),
                eshopProductsFooter: getDenormalizedEntities<EshopProductEntity>(state, EshopProductSchema, postDetailState.eshopProductsFooterIds),

                promoReviewArticlesHeader: getDenormalizedEntities<WikiArticleEntity>(state, WikiArticleSchema, postDetailState.promoReviewArticlesHeaderIds),
                promoReviewArticlesMiddle: getDenormalizedEntities<WikiArticleEntity>(state, WikiArticleSchema, postDetailState.promoReviewArticlesMiddleIds),
                promoReviewArticlesFooter: getDenormalizedEntities<WikiArticleEntity>(state, WikiArticleSchema, postDetailState.promoReviewArticlesFooterIds),

                userCanHavePregnancyNewsletter,
                postCanHavePregnancyNewsletter,
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            ...mkReduxFormMapDispatchToProps(COMMENT_CREATE_FORM_NAME),
            onLoad: postDetailFetchTrigger,
            onReply: postDetailCommentReply,
            onStoreEvent: analyticsStoreEvent,
            onReport: complaintOpenTrigger,
            onToggleMenuMore: (id: number) => menuToggle(FORUM_COMMENT_MENU_MORE(id)),
            onAddComment: postDetailCommentCreateTrigger,
            onAddCommentUnauthenticated: postDetailAddCommentUnauthenticated,
            onDeleteComment: postDetailCommentDeleteTrigger,
            onMoveUpComment: postDetailMoveUpComment,
            onScrollTo: postDetailScrollToTrigger,
            onToggleMenuMorePostDetail: () => menuToggle(POST_DETAIL_MENU_MORE),
            onToggleNotifications: (username: string, channelId: number, follow: boolean) =>
                postDetailToggleNotifications(username, 'thread', channelId, follow),
            onDelete: postDetailDeletePost,
            onTrackEdit: postDetailTrackTrigger,
            onSendHeart: postSendHeart,
            onToggleCommentHighlight: postDetailToggleCommentHighlight,
            onShowWarningToast: showWarningToastAction,
            onAddCounsellingQuestion: addCounsellingQuestion,
        };
    }

    public getMetaTitle(props: Props): string {
        const { post, pageRef, counselling } = props;

        let title = null;
        if (post && isNumber(pageRef)) {
            const plainHeading = boldize(post.heading, true)[0] as string;
            title = pageRef > 1
                ? interpolate(SEO_TITLE_FORUM_POST_title_AT_PAGE_pagenum, { title: plainHeading, pagenum: pageRef })
                : interpolate(SEO_TITLE_FORUM_POST_title, {title: plainHeading});
            if (counselling && post.comments) {
                title = `[${COUNSELLING_ANSWERED}] ${title}`;
            }
        }

        return title;
    }

    public getMetaDescription(props: Props): string {
        const { post } = props;
        return post
            ? interpolate(SEO_DESCRIPTION_FORUM_POST_perex, {perex: getFirstParagraphsPlaintext(post.perexAST)})
            : null;
    }

    public getOpenGraphData(props: Props, baseUrl: string, currentUrl: string): {[key: string]: string} {
        const { post } = props;

        if (post) {
            return {
                ...super.getOpenGraphData(props, baseUrl, currentUrl),
                ...postOG(baseUrl, post),
            };
        }
    }

    public getStructuredData(props: Props): object[] {
        const { post, baseUrl } = props;
        if (post) {
            const topic = post.topic ? post.topic : null;
            return [
                breadcrumbsForum(baseUrl, undefined, topic, post),
                discussionForumPosting(baseUrl, post),
            ];
        }
    }

    public getMetaRobots(props: Props): string {
        const { post } = props;
        return post && post.noindex ? 'noindex,nofollow' : 'index,follow';
    }

    public getCanonicalUrl(baseUrl: string, props: Props): string {
        const { pageRef, numberOfPages, post } = props;

        const hasPageNums: boolean = numberOfPages !== null && pageRef !== null && isNumber(pageRef);
        if (hasPageNums && post) {
            return baseUrl + postDetailUrl(post);
        }
    }

    public render(props: Props): false | JSX.Element {
        const { match, post, staticContext } = props;
        if (post) {
            // Redirects between /ask-an-expert/, /contests/ and /forum/
            if (isCounsellingPost(post) && match.path !== counsellingsPostDetailUrl) {
                if (staticContext) {
                    staticContext.statusCode = 301;
                    staticContext.url = url(counsellingsPostDetailUrl, match.params);
                } else {
                    // history.replace(url(counsellingsPostDetailUrl, match.params));
                }
            } else if (isContestPost(post) && match.path !== contestsPostDetailUrl) {
                if (staticContext) {
                    staticContext.statusCode = 301;
                    staticContext.url = url(contestsPostDetailUrl, {postSlug: match.params.postSlug});
                }
            } else if (!isCounsellingPost(post) && !isContestPost(post) && match.path !== forumPostDetailUrl) {
                if (staticContext) {
                    staticContext.statusCode = 301;
                    staticContext.url = url(forumPostDetailUrl, match.params);
                } else {
                    // history.replace(url(forumPostDetailUrl, match.params));
                }
            }
        }
        return (
            <>
                <PostDetail {...props} />
            </>
        );
    }

    public renderRight(props: Props): JSX.Element {
        return (
            <PostDetailRight {...props} />
        );
    }

    public hasHeaderBackButton(props: Props): boolean {
        return true;
    }

    public getDefaultBackPath(props: Props): string {
        const { match: { params: { topicSlug } } } = props;
        return url(forumTopicUrl, { topicSlug });
    }

    public getHalfpageProps(props: Props): HalfpageProps {
        const { post } = props;
        if (post && (post.deletedAt || post.isNoAds || post.topic.isCommercial)) {
            return null;
        }

        return {
            zone: 'Forum Thread - Halfpage Sticky (Desktop)',
        };
    }

    public getAnchorLeaderboardProps(props: Props): AnchorLeaderboardProps {
        const { isMobile, comments, post, currentFormPage, requestUser } = props;

        if (!isMobile || requestUser && !hasAds(requestUser)) {
            return null;
        }

        if (!post || post.deletedAt || post.isNoAds) {
            return null;
        }

        if (!post || (comments?.length || 0) < 8) {
            return null;
        }

        if (currentFormPage === FormPageType.Photos || currentFormPage === FormPageType.Stickers) {
            return null;
        }

        if (post.topic.isCommercial || post.topic.isBrandDays) {
            return null;
        }

        return {
            zone: 'Forum Thread - Anchor Ad Leaderboard (Mobile)',
        };
    }

    public getBrandingProps(props: Props): BrandingProps {
        const { location, post, currentFormPage } = props;

        // return BarandingProps even if post is not loaded, except contests / brand-days
        if (!post) {
            return (
                location.pathname.startsWith(contestsHomeUrl) ||
                location.pathname.includes('/dni-s')
            )
                ? null
                : { zone: 'Forum - Branding' };
        }

        if (post.deletedAt || post.isNoAds) {
            return null;
        }

        if (currentFormPage === FormPageType.Photos || currentFormPage === FormPageType.Stickers)
        {
            return null;
        }

        if (post.topic.isCommercial || post.topic.isBrandDays) {
            return null;
        } else {
            return {
                zone: 'Forum - Branding',
            };
        }
    }

    public getHeaderRight(props: Props): React.ReactElement {
        const { currentFormPage, onCloseFormPage } = props;
        return currentFormPage === FormPageType.Main
            ? this.getHeaderRightOnMainFormPage(props)
            : (
                <Btn
                    label={CONFIRM}
                    onClick={onCloseFormPage}
                />
            );
    }

    public getHeaderRightOnMainFormPage(props: Props): React.ReactElement {
        const {
            post, onToggleNotifications, onAddCounsellingQuestion,
            notificationsOn, requestUser, counselling, viewType, isMobile,
        } = props;

        if (!post || post.deletedAt || post.topic.deletedAt) {
            return null;
        }

        if (viewType === PostDetailViewType.Contest) {
            return null;
        } else if (viewType === PostDetailViewType.AskAnExpert) {
            return counselling && !counselling.isArchived && !counselling.isLocked && (
                <Btn
                    type={BtnType.Blue}
                    label={!counselling.isArchived ? FORUM_ADD_QUESTION : COUNSELLING_IS_ARCHIVED}
                    disabled={counselling.isArchived}
                    onClick={this.onAddPostClicked(() => { onAddCounsellingQuestion(counselling); }, `${counselling.id}`)}
                />
            );
        } else {
            const follow: boolean = notificationsOn.indexOf(post.id) > -1;

            return (
                <div className={styles.PostDetail__searchAndNotification}>
                    {isMobile && (
                        <Btn
                        className={styles.PostDetail__searchAndNotification__searchIcon}
                        type={BtnType.BlueOutline}
                        icon={faSearch}
                        link={forumSearchUrl}
                        />
                    )}
                    <Btn
                        type={BtnType.BlueOutline}
                        layout={BtnLayout.LabelIcon}
                        onClick={this.onToggleNotificationsCache(() => {
                            onToggleNotifications(requestUser.username, post.id, !follow);
                        }, requestUser.username, post.id, follow)}
                        icon={follow ? faBellSlash : faBell}
                        label={follow ? TURN_NOTIFICATIONS_OFF : TURN_NOTIFICATIONS_ON}
                    />
                </div>
            );
        }
    }

    public getSubmitButton(props: Props): React.ReactElement {
        /* not used submit button */
        return null;
    }

    public hasMobileLogo(props: Props): boolean {
        const { viewType } = props;

        // v poradni sa logo prekryva s dlhym action buttonom
        return  (viewType === PostDetailViewType.Contest || viewType === PostDetailViewType.AskAnExpert)
            ? super.hasMobileLogo(props)
            // vo fore pristava vela ludi zo searchu, kvoli brandingu tam chceme mat logo vzdy,
            // aj ked je vpravu nejaky button vpravo
            : true;
    }

    public registerInStore(store: Store<AppState>) {
        store.injectReducer('containers.forum.forumPostDetail', postsDetailReducer);
        store.injectSaga('containers.forum.forumPostDetail', postsDetailSaga);
    }

}
